var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.subscribed === 'PENDING')?_c('Loader'):_vm._e(),(_vm.subscribed === 'NO')?_c('Redirect'):_vm._e(),(_vm.subscribed === 'YES')?_c('AppStore'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }